var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.status === 'DRAFT')?_c('a-badge',{attrs:{"count":"Bản nháp","number-style":{
      backgroundColor: '#fff',
      color: '#999',
      boxShadow: '0 0 0 1px #d9d9d9 inset',
    }}}):(_vm.status === 'SUBMITTING')?_c('a-badge',{attrs:{"count":"Trình duyệt","number-style":{
      backgroundColor: '#1890ff',
      color: '#fff',
    }}}):(_vm.status === 'EDITING')?_c('a-badge',{attrs:{"count":"Chỉnh sửa","number-style":{
      backgroundColor: '#fdc032',
      color: '#fff',
    }}}):(_vm.status === 'APPROVED')?_c('a-badge',{attrs:{"count":"Đồng ý","number-style":{ backgroundColor: '#52c41a' }}}):(_vm.status === 'REJECTED')?_c('a-badge',{attrs:{"count":"Từ chối"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }